/**
 * Product Page Variant Updater for Black Friday Promo Ticker
 * ============================================================
 * Coordinates with PromoTickerManager in black-friday-promo-ticker.liquid
 * Subscribes to all Shopify variant change events and passes variant data directly
 */

(function() {
  'use strict';

  var inputValueCache = new Map();
  var pollingInterval = null;

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function updateSkuDisplay(sku) {
    var skuDisplay = document.querySelector('.variant-sku');
    if (skuDisplay) {
      skuDisplay.textContent = sku || '';
    }
  }

  function getVariantById(variantId) {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var variants = window.ShopifyAnalytics.meta.product.variants;
      var found = variants.find(function(v) { return v.id === variantId; });
      if (found) return found;
    }
    
    var productJsonEls = document.querySelectorAll('[data-product-json], script[type="application/json"][data-product]');
    for (var i = 0; i < productJsonEls.length; i++) {
      try {
        var productData = JSON.parse(productJsonEls[i].textContent);
        if (productData.variants) {
          var found = productData.variants.find(function(v) { return v.id === variantId; });
          if (found) return found;
        }
      } catch (e) {}
    }
    
    return null;
  }

  function extractVariantFromEvent(event) {
    if (!event) return null;
    
    var detail = event.detail;
    if (!detail) return null;
    
    var variant = detail.variant 
      || detail.selectedVariant 
      || detail.productVariant
      || detail.currentVariant
      || detail.selected_variant
      || (detail.product && detail.product.selectedVariant)
      || null;
    
    if (variant && variant.id) {
      return variant;
    }
    
    if (detail.id && (detail.sku !== undefined || detail.price !== undefined)) {
      return detail;
    }
    
    return null;
  }

  function getVariantInputFromForm(formElement) {
    if (!formElement) return null;
    var input = formElement.querySelector('input[name="id"], input[name="variant_id"]');
    return input;
  }

  function findClosestForm(element) {
    if (!element) return null;
    if (!(element instanceof Element)) return null;
    if (typeof element.closest !== 'function') return null;
    try {
      return element.closest('form, product-form, [data-product-form], .product-form');
    } catch (e) {
      return null;
    }
  }

  function notifyPromoTicker(variant) {
    if (!variant) {
      if (window.PromoTickerManager) {
        window.PromoTickerManager.debounceUpdate();
      }
      return;
    }

    updateSkuDisplay(variant.sku);

    if (window.PromoTickerManager) {
      window.PromoTickerManager.updateWithVariant(variant);
    } else if (typeof window.updateBFPromoPrice === 'function') {
      window.updateBFPromoPrice();
    }

    if (typeof window.updateStickyPrices === 'function') {
      window.updateStickyPrices();
    }

    document.dispatchEvent(new CustomEvent('variantUpdated', {
      detail: { variantId: variant.id, variant: variant }
    }));
  }

  function handleProductSelectChange() {
    var productSelect = document.getElementById('productSelect');
    if (!productSelect) return;

    var variantId = parseInt(productSelect.value);
    if (!variantId || isNaN(variantId)) return;

    var variant = getVariantById(variantId);
    notifyPromoTicker(variant);
  }

  function handleShopifyVariantEvent(event) {
    var variant = extractVariantFromEvent(event);
    
    if (variant) {
      notifyPromoTicker(variant);
      return;
    }
    
    var form = findClosestForm(event.target);
    if (form) {
      var input = getVariantInputFromForm(form);
      if (input && input.value) {
        var variantId = parseInt(input.value);
        if (variantId && !isNaN(variantId)) {
          variant = getVariantById(variantId);
          notifyPromoTicker(variant);
          return;
        }
      }
    }
    
    if (window.PromoTickerManager) {
      window.PromoTickerManager.debounceUpdate();
    }
  }

  function handleFormInputChange(event) {
    var target = event.target;
    if (!target) return;
    
    if (target.matches('select, input[type="radio"], input[type="hidden"]')) {
      setTimeout(function() {
        var form = findClosestForm(target);
        var hiddenInput = form ? getVariantInputFromForm(form) : null;
        
        if (!hiddenInput) {
          hiddenInput = document.querySelector('input[name="id"], input[name="variant_id"]');
        }
        
        if (hiddenInput && hiddenInput.value) {
          var variantId = parseInt(hiddenInput.value);
          if (variantId && !isNaN(variantId)) {
            var variant = getVariantById(variantId);
            notifyPromoTicker(variant);
            return;
          }
        }
        
        if (window.PromoTickerManager) {
          window.PromoTickerManager.debounceUpdate();
        }
      }, 50);
    }
  }

  function pollHiddenInputs() {
    var hiddenInputs = document.querySelectorAll('input[name="id"], input[name="variant_id"]');
    
    hiddenInputs.forEach(function(input) {
      var inputId = input.name + '_' + (input.form ? input.form.id || 'noform' : 'noform') + '_' + Array.prototype.indexOf.call(document.querySelectorAll('input[name="' + input.name + '"]'), input);
      var cachedValue = inputValueCache.get(inputId);
      var currentValue = input.value;
      
      if (cachedValue !== currentValue) {
        inputValueCache.set(inputId, currentValue);
        
        if (currentValue) {
          var variantId = parseInt(currentValue);
          if (variantId && !isNaN(variantId)) {
            var variant = getVariantById(variantId);
            if (variant) {
              notifyPromoTicker(variant);
            }
          }
        }
      }
    });
  }

  function startPolling() {
    if (pollingInterval) return;
    
    var hiddenInputs = document.querySelectorAll('input[name="id"], input[name="variant_id"]');
    hiddenInputs.forEach(function(input, index) {
      var inputId = input.name + '_' + (input.form ? input.form.id || 'noform' : 'noform') + '_' + index;
      inputValueCache.set(inputId, input.value);
    });
    
    pollingInterval = setInterval(pollHiddenInputs, 100);
  }

  function initProductPageUpdater() {
    var productSelect = document.getElementById('productSelect');

    if (productSelect) {
      productSelect.addEventListener('change', handleProductSelectChange);
    }

    document.addEventListener('variantChange', handleShopifyVariantEvent);
    document.addEventListener('stickyVariantChange', handleShopifyVariantEvent);
    document.addEventListener('variant:change', handleShopifyVariantEvent);
    document.addEventListener('variant:changed', handleShopifyVariantEvent);
    document.addEventListener('shopify:variant:change', handleShopifyVariantEvent);
    document.addEventListener('theme:variant:change', handleShopifyVariantEvent);

    var productForms = document.querySelectorAll('product-form, [data-product-form], .product-form, form[action*="/cart/add"]');
    productForms.forEach(function(form) {
      form.addEventListener('variant:change', handleShopifyVariantEvent);
      form.addEventListener('variant:changed', handleShopifyVariantEvent);
      form.addEventListener('change', handleFormInputChange);
    });

    var variantSelectors = document.querySelectorAll(
      'select[id^="productSelect-option-"], ' +
      '.single-option-selector, ' +
      '.variant-input, ' +
      '[data-variant-option], ' +
      '.product-form__input select, ' +
      '.product-form__input input[type="radio"]'
    );
    variantSelectors.forEach(function(selector) {
      selector.addEventListener('change', function(e) {
        var form = findClosestForm(e.target);
        setTimeout(function() {
          var hiddenInput = form ? getVariantInputFromForm(form) : null;
          if (hiddenInput && hiddenInput.value) {
            var variantId = parseInt(hiddenInput.value);
            if (variantId && !isNaN(variantId)) {
              var variant = getVariantById(variantId);
              notifyPromoTicker(variant);
              return;
            }
          }
          if (window.PromoTickerManager) {
            window.PromoTickerManager.debounceUpdate();
          }
        }, 50);
      });
    });

    startPolling();

    setTimeout(function() {
      if (productSelect) {
        handleProductSelectChange();
      } else if (window.PromoTickerManager) {
        window.PromoTickerManager.forceUpdate();
      }
    }, 100);

    console.log('[Product Page Updater] Initialized with Shopify event listeners and polling');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPageUpdater);
  } else {
    initProductPageUpdater();
  }
})();
